import React from "react";

import "./Loading.css";
import { CircularProgress } from "@mui/material";

export interface IPropsLoading {
	solid?: boolean;
	text?: string;
	total?: boolean;
	flagActive?: boolean;
}
const Loading: React.FC<IPropsLoading> = (props) => {

	return (
		<>
			{props.flagActive === true || props.flagActive === undefined ? (
				<>
					{props.total ? (
						<div className="loading" style={{ position: "fixed" }}>
							<header
								className={
									props.solid
										? "loading-header"
										: "loading-header-trasparent"
								}
							>
								<CircularProgress size={125} />
								<p>{props.text ?? "Loading"}</p>
							</header>
						</div>
					) : (
						<div className="loading" style={{ position: "fixed" }}>
							<header
								className={
									props.solid
										? "loading-header"
										: "loading-header-trasparent"
								}
							>
								<CircularProgress size={125} />
								<p>{props.text ?? "Loading"}</p>
							</header>
						</div>
					)}
				</>
			) : (
				<></>
			)}
		</>
	);
};

export default Loading;
